import React, { useContext, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, KeyOutlined, WarningOutlined } from '@ant-design/icons';
import { checkLogin, loginToFirebase, rememberLoginUser } from '../actions'
import { StoreContext } from "../store"
import firebase from 'firebase/app'
import 'firebase/functions';

import {
  checkUserRole,
} from "../Api";

const LoginCard = ({redirect},props) => {
  const { state:{ userSignin: { userInfo, loading, error, remember } }, dispatch } = useContext(StoreContext);
  const [form] = Form.useForm();
  const history = useHistory();
  //const { state: {...all}, dispatch2 } = useContext(StoreContext);

  //console.log('LoginCard enter: ', all);
  
  const AdminLogin = () => {
    console.log('L1/L2 adminLogin');
    //history.push("customermag");
    history.push("autotestdis"); 
  };

  const UserLogin = () => {
    console.log('L3/L4 user Login');
    history.push("robotmagL3L4"); //Anita 0518 --add
  };
 
  const onFinish = async (values) => {
    console.log('Received values of form: ', values);
    const user = await loginToFirebase(dispatch, values);
    var role = await checkUserRole(user["user"]["uid"]);
    console.log('user role->', role);

    //if(role === "L0" || role === 'L1'|| role === 'L2'){
      AdminLogin();
    //}else{
      //UserLogin();
    //}

  };

  const onChange = e => {
    rememberLoginUser(dispatch, e.target.checked);
  }

  useEffect(() => {    
    if( userInfo && checkLogin(dispatch) ) history.push(redirect);
  }, [ userInfo ]);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="main-layout">
      <div className="login-form-wrapper">
        <div>
          <img src="/images/ad_1_img.png" className="ad_1"/>
        </div>
      </div>
      <div className="login-form">
        <div className="logo">
          <img src="/images/company logo.png" />
        </div>
        <Form
          name="normal_login"
          className="login-form_list"
          form={form}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
        <Form.Item
          name="email"
          className="login-email"
          rules={[
            {
              required: true,
            },
          ]}
          hasFeedback
        >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="Account"
          style={{width:400,color:"#000"}}
        />
        </Form.Item>
        <Form.Item
          name="password"
          className="login-password"
          rules={[
            {
              required: true,
              color:'#fff500',
              message: "Incorrect password,please try again.",
            }
          ]}
          hasFeedback
        >
          <Input.Password
            prefix={<KeyOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            style={{width:400,color:"#000"}}
          />
        </Form.Item>
        <Form.Item className="login-enter">
          
            <Button
              htmlType="submit"
              className="login-form__button"
             
            >
              Login
            </Button>
      
          {error === "" ? (
            <></>
          ) : (
            <div className="login-form__error-wrap">
              <h3 className="login-form__error-title">
                <WarningOutlined />
                {"  "}There was a problem...
              </h3>
              <p className="login-form__error-message">{error}</p>
            </div>
          )}
        </Form.Item>
        <Form.Item>
          <Form.Item
            className="remember"
            noStyle
          >
            <Checkbox className="remember" onChange={onChange} checked={remember}>Remember me</Checkbox>
          </Form.Item>
          <Form.Item className="login-form__forgot">
            <Link  to={""}>
              Forgot password
            </Link>
          </Form.Item>
        </Form.Item>
        </Form>
        <div>
          <div className="login_info">Please read the Privacy policy and terms 
          Copyright by URSROBOT Inc.</div>
        </div>
      </div>
    </div>
  );
};
export default LoginCard;